export function getFlatOptions(options, includeDisabled) {
    if (includeDisabled === void 0) { includeDisabled = true; }
    var result = [];
    options.forEach(function (option) {
        if (includeDisabled || !option.disabled) {
            if ('options' in option) {
                result.push.apply(result, getFlatOptions(option.options, includeDisabled));
            }
            else {
                result.push(option);
            }
        }
    });
    return result;
}
export function getOptionId(controlId, optionIndex) {
    return controlId + "-option-" + optionIndex;
}
export function getHighlightedId(controlId, options, highlightedOption) {
    var highlightedIndex = getFlatOptions(options).indexOf(highlightedOption);
    return highlightedIndex > -1 ? getOptionId(controlId, highlightedIndex) : undefined;
}
export function getOptionGroup(option, options) {
    for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
        var group = options_1[_i];
        if (group && 'options' in group) {
            if (group.options.indexOf(option) !== -1) {
                return group;
            }
        }
    }
    return undefined;
}
export function isOptionSelected(option, selectedOptions) {
    return selectedOptions.some(function (selected) { return selected.id === option.id; });
}
function findOption(currentOption, allOptions) {
    for (var _i = 0, allOptions_1 = allOptions; _i < allOptions_1.length; _i++) {
        var option = allOptions_1[_i];
        if (option.id === currentOption.id) {
            return option;
        }
    }
    return null;
}
export function isOptionDisabled(currentOption, allOptions) {
    if (currentOption.disabled) {
        return true;
    }
    for (var _i = 0, allOptions_2 = allOptions; _i < allOptions_2.length; _i++) {
        var option = allOptions_2[_i];
        if ('options' in option) {
            if (option.disabled) {
                var match = findOption(currentOption, option.options);
                if (match) {
                    return true;
                }
            }
        }
        else if (option.id === currentOption.id) {
            return option.disabled;
        }
    }
    return false;
}
//# sourceMappingURL=options.js.map